import { Component, OnInit } from '@angular/core';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {

  public receiptApproved = false;
  confirmReceiptSubmitted = false;
  scanningData : any[] = [];
  failedChecks = 0;

  reasons: any[] = [];

  constructor(private coreService: CoreService) { }

  ngOnInit() {
    this.receiptApproved = this.coreService.isReceiptApproved;
    this.scanningData = this.coreService.scanningReasons;
    let productFoundData = {
      key: 'Product Found',
      value: this.scanningData.indexOf('Product Found: Yes') === -1 ? false : true
    }
    this.reasons.push(productFoundData);
    let dateOkData = {
      key: 'Date Ok',
      value: this.scanningData.indexOf('Date Ok: Yes') === -1 ? false : true
    }
    this.reasons.push(dateOkData);
    let duplicateReceiptData = {
      key: 'Receipt OK',
      value: this.scanningData.indexOf('Duplicate Receipt: Yes') === -1 ? true : false
    }
    this.reasons.push(duplicateReceiptData);
    this.failedChecks = this.reasons.filter((reason:any) => reason.value === false).length;
  }

  onReceiptConfirm() {
    this.coreService.confirmReceiptUpload(this.coreService.recptPartitionKey, this.coreService.recptRowKey)
      .then((response: any) => {
        this.confirmReceiptSubmitted = true;
      });
  }

}
